module.exports = __webpack_public_path__ + "static/media/arrow-downwards.098801e7.png";